<script setup lang="ts">
import { computed, onMounted } from 'vue';

import { useAppInfoStore } from '@/stores/appInfo';
import IconArrowSquare from '~icons/lucide/external-link';

const props = withDefaults(
  defineProps<{
    path?: string;
    showNewTabIcon?: boolean;
  }>(),
  {
    path: '',
    showNewTabIcon: true,
  },
);

const appInfoStore = useAppInfoStore();

const computedPath = computed(() => {
  if (props.path[0] === '/') return props.path.slice(1);
  return props.path;
});

const docsVersion = computed(() => {
  const currentVersion = appInfoStore.upgradeInfo?.currentVersion;
  const latestVersion = appInfoStore.upgradeInfo?.latestVersion;

  if (currentVersion && latestVersion) {
    return currentVersion === latestVersion ? 'latest' : currentVersion;
  }

  // Fallback to existing logic if upgradeInfo is not available
  return appInfoStore.systemVersion;
});

onMounted(async () => {
  if (appInfoStore.upgradeInfo === null) {
    await appInfoStore.fetchUpgradeInfo();
  }
});
</script>

<template>
  <a
    target="_blank"
    rel="noopener noreferrer"
    class="inline-flex items-center gap-1 font-semibold"
    :href="`https://docs.kasten.io/${docsVersion}/${computedPath}`"
    @click.stop
  >
    <slot />
    <IconArrowSquare v-if="showNewTabIcon" class="size-4" />
  </a>
</template>
